/**
 * @generated SignedSource<<b2a02b4d3c4cb00457f606ba0f196d17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionScreenRoutineDescription_Routine$data = {
  readonly isOrg: boolean;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionDescriptionContent_Routine">;
  readonly " $fragmentType": "RoutineOccasionScreenRoutineDescription_Routine";
};
export type RoutineOccasionScreenRoutineDescription_Routine$key = {
  readonly " $data"?: RoutineOccasionScreenRoutineDescription_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionScreenRoutineDescription_Routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionScreenRoutineDescription_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineOccasionDescriptionContent_Routine"
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "fa3bebf7006daf4d81fba62e81388767";

export default node;
